import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import ImgPlaceholder from "../../assets/ImgPlaceholder.svg";
import { useUserDataStore } from "../../stores/user";
const AdminLayout = () => {
  const { userData } = useUserDataStore();

  return (
    <div className="bg-dashboardBg flex min-h-screen font-inter">
      <Sidebar />
      <div className="w-full">
        <div className="bg-white w-full ">
          <div className="flex justify-end px-8 max-w-[1200px] ml-auto w-full h-[70px] items-center">
            <div className="flex gap-5">
              <div className="w-11 h-11">
                <img
                  src={userData?.img_url ?? ImgPlaceholder}
                  className="w-full h-full object-cover object-[75%_25%] rounded-full"
                  alt=""
                />
              </div>
              <div>
                <h1 className="font-bold text-sm mb-1 capitalize">
                  {userData?.firstName}
                </h1>
                <p className="text-sm font-semibold">
                  {userData?.role === "admin" ? "Admin" : "Sales"}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className=" px-8 max-w-[1300px] mx-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
